module.exports = __webpack_public_path__ + "img/1737006734371.0c25cd6d.png";